<template>  
  <v-card flat class="container--fluid">
      <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
        <v-card flat class="v-card__container">    
          <h4>Handledarinstruktioner</h4>
        </v-card>
      </v-card>
    
    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <v-card-text>Ange datum då handledarinstruktionerna uppdaterades.</v-card-text>
        <v-card-text>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="newInstructionsAt"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="newInstructionsAt"
                label="Ange datum"
                outlined
                prepend-inner-icon="$sl-calendar"
                readonly
                v-on="on"
                
              ></v-text-field>
            </template>
            <v-date-picker v-model="newInstructionsAt" no-title scrollable>              
              
              <v-btn class="icon" color="secondary" @click="menu = false">
                <v-icon>$sl-cancel</v-icon>
                Avbryt</v-btn>
              <v-btn @click="$refs.menu.save(newInstructionsAt)">OK</v-btn>
              
            </v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="saveSettings">Spara</v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters, mapActions } from 'vuex'
import { RulesMixin } from '@/components/mixins'
// @group Common
// SystemSettings component
export default {
  name: 'SystemSettings',

  mixins: [
    RulesMixin
  ],

  data: () => ({
    menu: false
  }),

  created() {
  },

  computed: {
    ...mapGetters('basic', ['systemSettings']),

    newInstructionsAt: {
      get: function () {
        return this.$options.filters.date(this.systemSettings.newInstructionsAt)
      },
      set: function (newValue) {
        this.systemSettings.newInstructionsAt = newValue
      }
    }
  },

  methods: {
    ...mapActions('basic', ['updateSystemSettings']),
    /**
     * @vuese
     *  Used to save system settings
     *  @arg the argument is an object representing new instructions
     */
    saveSettings() {

      const data = {newInstructionsAt: this.newInstructionsAt}

      API.saveSystemSettings({data: data})
      .then(res => {
        this.$events.fire('showInfo', 'Sparad.')
        return this.updateSystemSettings(data)
      })
      .catch(err => {
        console.log(err)
        this.$events.fire('showError', 'Inställningarna kunde inte sparas.')
      })
    }
  }
 
}
</script>

<style lang="scss" scoped>
</style>